
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/canada-regional-events",
      function () {
        return require("private-next-pages/events/canada-regional-events/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/canada-regional-events"])
      });
    }
  